export default __webpack_public_path__ + "static/media/IMG_2027.04bab30d.JPG";